<style scoped>

  .sdform-wrap .simple .area-box .choose-city{display:flex;position:relative;cursor:pointer}
  .sdform-wrap .simple .area-box .choose-city .province-city-select{width:100%;height:100%;position:absolute;left:0;top:0;overflow:hidden;opacity:0}
  .sdform-wrap.green .brand-item.active{color:#db2017  !important;background:rgb(196 25 80 / 10%) !important;border:1px solid transparent !important}
  .sdform-wrap .simple .brand-box .brand-list .brand-item .icon-clear{position:absolute;right:-.4166666667vw;top:-.4166666667vw;color:#909594}
  .el-icon-error:before{content:"\e79d"}
  .global-tooltip{position:fixed;top:30%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,0.8);color:#fff;padding:16px 32px;border-radius:6px;z-index:9999;font-size:16px}
  .sd-suspend .icon{margin-bottom:0px}
  .privacy-box.error{
    animation: shake-data-v-cd42dfd4 .5s;
    animation-iteration-count: 1;
  }
  .sdform-wrap.green .high-color{color:#db2017 !important;}
  .sdform-wrap .simple .brand-box .brand-text{margin-right:10px;}
  @keyframes shake-data-v-cd42dfd4 {
    0% {
        transform: translateY(0);
    }
    25% {
        transform: translateY(-5px);
    }
    50% {
        transform: translateY(5px);
    }
    75% {
        transform: translateY(-5px);
    }
    100% {
        transform: translateY(5px);
    }
  }
</style>
<template>
  <div class="sd-suspend lead-retention-class green">
    <div class="icon-wrap icon-apply active">
      <div class="item">
        <div class="icon"></div>
        <p class="ws">Hợp tác</p>
      </div>
    </div>
    
    <div class="icon-backtop">
      <div class="item"><img src="/img/icon-up.bb52718.png" alt class="icon-up"></div>
    </div>
    <div class="sdform-wrap form-input-class green">
      <div class="triangle"></div>
      <div class="close-icon"></div>
      <div class="simple">
        <div class="title-1">
          Tham gia <span class="high-color">Fast Charge</span> đối tác
        </div>
        <div class="title-2">Nắm bắt cơ hội thị trường tỷ đô!!</div>
        <div class="form-wrap">
          <div class="form">
            <div class="form-item item-tel">
              <span class="icon icon-phone"></span>
              <input type="tel" name="phone" placeholder="Nhập số điện thoại để nhận chính sách đầu tư mới nhất miễn phí" maxlength="11" v-model="phone" class="phone-input" @input="showPhoneError = false">
              <div class="error-msg" v-if="showPhoneError">Vui lòng nhập đúng số điện thoại</div>
            </div>
          </div>
          <div class="brand-box">
            <div class="brand-text">Sản phẩm quan tâm:</div>
            <div class="brand-list">
              <div class="brand-item" :class="{ active: activeBrand.includes('Sạc dự phòng') }" @click="toggleBrand('Sạc dự phòng')">
                <span>Sạc dự phòng</span>
                <i v-if="activeBrand.includes('Sạc dự phòng')" class="el-icon-error icon-clear"></i>
              </div>
              <div class="brand-item" :class="{ active: activeBrand.includes('Trạm sạc') }" @click="toggleBrand('Trạm sạc')">
                <span>Trạm sạc</span>
                <i v-if="activeBrand.includes('Trạm sạc')" class="el-icon-error icon-clear"></i>
              </div>
            </div>
          </div>
          <button class="btn-wrap" @click="submitForm"><span class="btn-text">Tham gia ngay</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { BASE_URL } from '@/config';
import qs from 'qs';
import axios from 'axios'; // 引入 axios

export default {
  name: "vueRight", // 组件名称
  props: {
    label: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      options: [], // 当前组件的独立数据
      phone: '',
      province: "", // 当前选中的省份 ID
      city: "", // 当前选中的城市 ID
      provinces: [], // 省份列表
      cities: [], // 当前省份对应的城市列表
      value: [],
      activeBrand: [],
      agreePrivacy: false,
      showPhoneError: false,
      showPrivacyError: false,
      BASE_URL,
      
    };
  },
  computed: {
    selectedProvinceCity() {
      if (!this.value || this.value.length === 0) return '';
      const province = this.options.find(p => p.value === this.value[0]);
      if (!province) return '';
      if (this.value.length === 1) return province.label;
      const city = province.children.find(c => c.value === this.value[1]);
      return city ? `${province.label} ${city.label}` : province.label;
    }
  },
  methods: {
    showGlobalTooltip(msg) {
    // 创建或获取全局提示元素
    let tooltip = document.querySelector('.global-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'global-tooltip';
      document.body.appendChild(tooltip);
    }
    tooltip.innerText = msg;
    tooltip.style.display = 'block';

    // 2秒后自动隐藏
    clearTimeout(this._tooltipTimer);
    this._tooltipTimer = setTimeout(() => {
      tooltip.style.display = 'none';
    }, 2000);
  },
    
    openCascader() {
  this.$refs.cityCascader.toggleDropDownVisible(true);
},

 toggleBrand(brand) {
  const idx = this.activeBrand.indexOf(brand);
  if (idx > -1) {
    this.activeBrand.splice(idx, 1); // 已选中则移除
  } else {
    this.activeBrand.push(brand); // 未选中则添加
  }
},

    handleChange() {
      
  // ...你的其它逻辑
  
},
    

   
   
  
    togglePrivacy() {
      this.agreePrivacy = !this.agreePrivacy;
      if (this.agreePrivacy) {
        this.showPrivacyError = false;
      }
    },
   
    submitForm() {
      let hasError = false;

      // 校验手机号
      if (!this.phone || !/^1\d{10}$/.test(this.phone)) {
        this.showPhoneError = true;
        hasError = true;
      } else {
        this.showPhoneError = false;
      }

      
      // 如果有任何错误，直接返回
      if (hasError) return;
    
     

      
      axios.post('https://admin.metfastcharge.net/index/msg?fcode=3&lang=vn', qs.stringify({
        phone: this.phone,
        products: this.activeBrand.join(',') // 数组
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then(response => {
        if (response.data.status === 'success') {
          this.showGlobalTooltip('Tin nhắn thành công');
          // 清空表单
          this.phone = '';
          this.value = [];
          this.activeBrand = [];
          this.agreePrivacy = false;
        }
        if (response.data.status === 'fail') {
          this.showGlobalTooltip('Tin nhắn thất bại');
        }
      })
      .catch(error => {
        console.error("提交失败：", error);
        this.showGlobalTooltip("Gửi không thành công, vui lòng kiểm tra kết nối mạng!");
      });

    },
  },
  mounted() {
    this.loadProvinces();
  },
 
};
</script>

